import { createIsomorphicFn, createServerOnlyFn } from '@tanstack/react-start';

const signDataOnServer = createServerOnlyFn(async (data: string) => {
    const secret = process.env.OG_DATA_SECRET;
    if (!secret) {
        throw new Error('OG_DATA_SECRET is not defined');
    }
    return await hmac256Hex(secret, data);
});

export const convertOGDataToPayload = createIsomorphicFn()
    .server(async (input: object): Promise<string | undefined> => {
        try {
            const json = JSON.stringify(input);
            const data = base64url(new TextEncoder().encode(json));
            const signature = await signDataOnServer(data);
            return `${data}.${signature}`;
        } catch (error) {
            console.error('Failed to convert OG data to payload:', error);
            return undefined;
        }
    })
    .client(() => undefined);

function base64url(bytes: Uint8Array): string {
    let bin = '';
    for (let i = 0; i < bytes.length; i += 0x8000) {
        bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
    }
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function hex(u8: Uint8Array): string {
    let out = '';
    for (let i = 0; i < u8.length; i++)
        out += u8[i].toString(16).padStart(2, '0');
    return out;
}

async function hmac256Hex(secret: string, data: string): Promise<string> {
    const key = await crypto.subtle.importKey(
        'raw',
        new TextEncoder().encode(secret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign'],
    );
    const sig = await crypto.subtle.sign(
        'HMAC',
        key,
        new TextEncoder().encode(data),
    );
    return hex(new Uint8Array(sig));
}
